import React, { useEffect, useRef, useState } from "react";
import styles from "./ClientsView.module.css";
import { useDispatch, useSelector } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AddClientModal from "./addClientModal";
import moveRightIcon from '../../assets/images/nextRight.png'
import moveRightIconFocus from '../../assets/images/nextRightFocus.png'
import { FilterMatchMode } from "primereact/api";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import EditClientModal from "./editClientModal";
import { getClients } from "../../components/clients/clientsSlice";
import { useNavigate } from "react-router-dom";
import archiveIcon from '../../assets/images/archive.png'
import archiveIconFocus from '../../assets/images/archiveFocus.png'
import InactiveClientsModal from "./InactiveClientsModal";
import { isAdmin } from "../../app/utils/helpers";
import moment from "moment";


export default function ClientsTab() {

    const mounted = useRef(null)
    const dispatch = useDispatch()
    const clients = useSelector((state) => state.clients.list)
    const isMobile = useSelector((state) => state.settings.isMobile);
    const navigate = useNavigate()
    const [clientsList, setClientsList] = useState([])
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const [addClientModalVisibility, setAddClientModalVisibility] = useState(false)
    const [onEditClient, setOnEditClient] = useState(null)
    const [inactiveModalVisibility, setInactiveModalVisibility] = useState(false);

    const [editClientModalVisibility, setEditClientModalVisibility] = useState(false);
    const userRoleId = useSelector((state) => state.login.userRoleId)

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
        vfact: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })

    const [globalFilterValue, setGlobalFilterValue] = useState('')

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getClients())
        }
        mounted.current = true
    }, [mounted])

    useEffect(() => {
        setClientsList(clients)
    }, [clients])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const creationDateBodyTemplate = (rowData, column) => {
        if (rowData[column.field]) {
            return <label>
                {moment(rowData[column.field]).format("DD/MM/YYYY HH:mm")}
            </label>
        }
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
                <div>
                    {isAdmin(userRoleId) && <ImageButton
                        image={archiveIcon}
                        imageFocus={archiveIconFocus}
                        onClick={() => setInactiveModalVisibility(true)}
                        active={true}
                        tooltip={<Langs str="Archive" />}
                        width={32} />}
                    <ImageButton
                        image={addIcon}
                        imageFocus={addIconFocus}
                        onClick={() => setAddClientModalVisibility(true)}
                        active={true}
                        tooltip={<Langs str="ADD_CLIENT" />}
                        width={32} />
                </div>
            </div>
        );
    };
    const header = renderHeader();
    const editRowFun = (rowData) => {
        setOnEditClient(rowData.data)
        setEditClientModalVisibility(true)
    }

    const navToTeam = (rowData) => {
        return (
            <dev>
                <ImageButton
                    image={moveRightIcon}
                    imageFocus={moveRightIconFocus}
                    tooltip={<Langs str="JUMP_TO_TEAMS" />}
                    active={true}
                    onClick={() => {
                        const encodedLabel = encodeURIComponent(rowData.label);
                        navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
                    }}
                    width={32}
                />
            </dev>
        )
    };

    const [expandedId, setExpandedId] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = (id) => {
        if (isExpanded && expandedId === id) {
            setIsExpanded(false);
            setExpandedId(null);
        } else {
            setIsExpanded(true);
            setExpandedId(id);
        }
    };

    const respColBody = (rowData) => {
        if (rowData && rowData.managers && rowData.managers.length > 0) {
            return (
                <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                    {rowData.managers.slice(0, (isExpanded && expandedId === rowData.id) ? rowData.managers.length : 3).map((manager, index) => (
                        <li key={index} style={{
                            position: 'relative',
                            paddingLeft: '20px',
                            wordWrap: 'break-word',
                            maxWidth: '35ch',
                            marginBottom: '8px'
                        }}>
                            <span style={{
                                position: 'absolute',
                                left: '0',
                                top: '0'
                            }}>•</span>
                            {manager.prenom} {manager.nom}
                        </li>
                    ))}
                    {rowData.managers.length > 3 && (
                        <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleToggle(rowData.id)}>
                            {isExpanded && expandedId === rowData.id ? Localize('SHOW_LESS') : `${Localize('SHOW_MORE')} (${rowData.managers.length - 3} ${Localize('MORE')})`}
                        </li>
                    )}
                </ul>
            );
        } else {
            return <p>N/A</p>;
        }
    }

    return (
        <div className={styles.bodyContainer}>
            <div className="card p-1 mt-3" style={{ height: 'calc(100vh - 160px)' }}>
                <DataTable
                    value={clientsList}
                    scrollHeight={isMobile === 2 ? "calc(100vh - 200px)" : "calc(100vh - 305px)"}
                    scrollable
                    paginator
                    currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[25, 50, 100]}
                    rows={50}
                    sortMode="single"
                    globalFilterFields={['nom', 'vfact']}
                    filters={filters}
                    header={header}
                    onRowDoubleClick={editRowFun}
                    rowClassName={styles.rowClassHover}
                >
                    <Column field="nom" filter filterMatchMode={'contains'} showFilterMenu={false} header={<Langs str='Nom' />} sortable></Column>
                    <Column field="vfact" header={<Langs str='V-Fact Client' />} sortable></Column>
                    <Column header={Localize('RESP_COMPTE')} style={{ minWidth: '10rem' }} body={respColBody} />
                    <Column field="createdBy" header={<Langs str='created_by' />} sortable></Column>
                    <Column field="createdAt" header={Localize("created_at")} body={creationDateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
                    <Column field="viewDetails" body={navToTeam} style={{ minWidth: '2rem', textAlign: 'right' }} alignFrozen="right" frozen={true}></Column>
                </DataTable>
                <AddClientModal
                    visible={addClientModalVisibility}
                    setVisible={setAddClientModalVisibility}
                />
                <EditClientModal
                    visible={editClientModalVisibility}
                    setVisible={setEditClientModalVisibility}
                    client={onEditClient}
                    setClient={setOnEditClient}
                />
                <InactiveClientsModal
                    visible={inactiveModalVisibility}
                    setVisible={setInactiveModalVisibility}
                />
            </div>
        </div>
    )
}